// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	

	let version = "bev"   //  "regular"  or "bev"
	if (version==="regular"){
		expandRegular()
		collapseNew()
	}
	if (version==="bev"){
		expandNew()
		collapseRegular()
	}

function expandNew(){
	for (let i=1; i<7; i++)
	{$w("#bev"+i).expand()}
}

function collapseNew(){
	for (let i=1; i<9; i++)
	{$w("#bev"+i).collapse()}
}


function expandRegular(){
	for (let i=1; i<5; i++)
	{$w("#regular"+i).expand()}
}

function collapseRegular(){
	for (let i=1; i<5; i++)
	{$w("#regular"+i).collapse()}
}

});